export const MENSAGEM_DOCUMENTO_INDISPONIVEL = "Documento não disponível para esta operadora.";

export interface ResultadoDocumento {
  url?: string;
  erro?: string;
}

interface RetornoConsulta {
  data?: { estabelecimentoDownload?: string | null } | null;
}

const mensagemDaFalha = (falha: any): string => {
  const bruta = falha && falha.message ? String(falha.message) : "";
  const limpa = bruta.replace(/^GraphQL error:\s*/i, "").trim();
  return limpa.length > 0 ? limpa : MENSAGEM_DOCUMENTO_INDISPONIVEL;
};

export const obterDocumento = async (
  consultar: () => Promise<RetornoConsulta>,
  host?: string
): Promise<ResultadoDocumento> => {
  let retorno: RetornoConsulta;
  try {
    retorno = await consultar();
  } catch (falha) {
    return { erro: mensagemDaFalha(falha) };
  }

  const nomeArquivo = retorno && retorno.data ? retorno.data.estabelecimentoDownload : null;
  if (!nomeArquivo || String(nomeArquivo).trim().length === 0) {
    return { erro: MENSAGEM_DOCUMENTO_INDISPONIVEL };
  }

  return { url: `${host || ""}/temp/${String(nomeArquivo).trim()}` };
};
